module.exports = ".wraper {\n  background-image: url(/assets/logos/login_bg.jpeg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  height: 100vh;\n}\n\n.err-msg {\n  color: red;\n}\n\n.container-wrapper .sk-circle {\n  margin: 0 auto !important;\n  margin-bottom: 20px !important;\n}\n\n.btn-disabled {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main